// extracted by mini-css-extract-plugin
module.exports = {"trailersWrapper":"rp","trailerHeader":"rq","trailers":"rr","trailer":"rs","imgWrapper":"rt","playWrapper":"ru","playImg":"rv","title":"rw","slipnslideArrow":"rx"};